// src/config/axios.ts

import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://abogado-backend.romarqtech.com',
});

api.interceptors.request.use(
    (config) => {
        // --- AÑADIMOS ESTOS LOGS PARA DEPURAR ---
        console.log('%cAxios Interceptor: Ejecutado para la ruta ->', 'color: purple; font-weight: bold;', config.url);
        
        const token = localStorage.getItem('accessToken');

        if (token) {
            console.log('%cAxios Interceptor: ¡Token encontrado! Añadiendo cabecera...', 'color: green; font-weight: bold;');
            config.headers['Authorization'] = `Bearer ${token}`;
        } else {
            console.log('%cAxios Interceptor: ADVERTENCIA - No se encontró token en localStorage.', 'color: red; font-weight: bold;');
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;